export default "__VITE_ASSET__CfXo4szz__"